// extracted by mini-css-extract-plugin
module.exports =  {"FRAME":"FRAME","STACK":"STACK","GRID":"GRID","box":"box--pgS7m","custom-bg":"custom-bg--LcGB7","customBg":"custom-bg--LcGB7"};